import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import CategoryWrapper from '../components/Category/CategoryWrapper';
import CategoryHeader from '../components/Category/CategoryHeader';
import CategoryBody from '../components/Category/CategoryBody';
import ProductVertical from '../components/ProductVertical';
import ProductHorizontal from '../components/ProductHorizontal';
import { useDispatch, useSelector } from 'react-redux';
import { allPostsState$, postsLatestState$, totalPostsState$ } from '../redux/selectors';
import { getRelatedPosts, searchPosts } from '../redux/actions';
import { useParams } from 'react-router-dom';

export default function Posts({ location }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const posts = useSelector(allPostsState$);
  const latestPosts = useSelector(postsLatestState$);
  const totalPosts = useSelector(totalPostsState$);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  let title = '';
  let result = null;
  let searchBy = 'product';
  const currentTotal = posts && posts.length;

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [searchBy]);

  switch (location.pathname) {
    case '/applications':
      searchBy = 'application';
      title = `Có ${totalPosts} ứng dụng`;
      result = (
        <CategoryBody itemPerRow={2}>
          {posts && posts.map(item => {
            const { _id, title, ...rest } = item;
            return (
              <ProductHorizontal
                key={_id}
                path={`/applications/${_id}`}
                title={title}
                {...rest}
              />
            )
          })}
        </CategoryBody>
      );
      break;
    case '/promotion-codes':
      searchBy = 'promotion-code';
      title = `Có ${totalPosts} mã giảm giá`;
      result = (
        <CategoryBody itemPerRow={4}>
          {posts && posts.map(item => {
            const { _id, image, title, ...rest } = item;
            const images = (
              <img
                src={image}
                alt={title}
                width="180"
                height="180"
              />
            );
            return (
              <ProductVertical
                key={_id}
                path={`/promotion-codes/${_id}`}
                promotion={true}
                images={images}
                title={title}
                {...rest}
              />
            )
          })}
        </CategoryBody>
      );
      break;
    case '/products':
      searchBy = 'product';
      title = `Có ${totalPosts} sản phẩm`;
      result = (
        <CategoryBody itemPerRow={3}>
          {posts && posts.map(item => {
            const { _id, image, title, ...rest } = item;
            const images = (
              <>
                <img
                  src={image}
                  alt={title}
                />
              </>
            );
            return (
              <ProductVertical
                key={_id}
                path={`/products/${_id}`}
                images={images}
                title={title}
                {...rest}
              />
            )
          })}
        </CategoryBody>
      );
      break;
    default:
      searchBy = (location.search && location.search.split('?value=')[1]) || '';
      title = `Tìm thấy ${totalPosts} kết quả cho "${searchBy}"`;
      result = (
        <CategoryBody itemPerRow={2}>
          {posts && posts.map(item => {
            const { _id, category, title, ...rest } = item;
            return (
              <ProductHorizontal
                key={_id}
                path={`/${category}s/${_id}`}
                title={title}
                {...rest}
              />
            )
          })}
        </CategoryBody>
      );
      break;
  }

  useLayoutEffect(() => {
    setHasMore(currentTotal < totalPosts);
  }, [currentTotal, totalPosts])

  useEffect(() => {
    if (id === 'type') {
      dispatch(getRelatedPosts.sendRelatedPostsRequest({
        type: searchBy,
      }));
    } else {
      dispatch(searchPosts.sendSearchPostsRequest({
        searchBy,
        pageNumber: 1
      }));
    }
    setPageNumber(1);
  }, [dispatch, searchBy, id])

  const fetchMore = useCallback(() => {
    dispatch(searchPosts.sendSearchPostsRequest({
      searchBy,
      pageNumber: pageNumber + 1,
      fetchMore: true,
    }));
    setPageNumber(pageNumber + 1);
  }, [dispatch, searchBy, pageNumber]);

  return (
    <div className="row" style={{ width: '99%', margin: 'auto' }}>
      <div className="col-lg-8">
        <CategoryWrapper>
          <CategoryHeader
            left={
              <>
                <img
                  src="https://salt.tikicdn.com/ts/upload/c5/0e/02/23066556738e7f5df8b8fde5d0d1dfd6.png"
                  alt="Icon"
                  width="24"
                />&nbsp;{title}
              </>
            }
          />
          {result}
          {hasMore
            ? (
              <div className="text-center pt-3">
                <button className="btn btn-primary fw-bold" onClick={fetchMore}>XEM THÊM</button>
              </div>
            ) : null}
        </CategoryWrapper>
      </div>
      <div className="col-lg-4">
        <CategoryWrapper>
          <CategoryHeader
            left={
              <div>Bài đăng mới nhất</div>
            }
          />
          <CategoryBody itemPerRow={1}>
            {latestPosts && latestPosts.map(item => {
              const { _id, category, title, ...rest } = item;
              return (
                <ProductHorizontal
                  key={_id}
                  isSideBar={true}
                  path={`/${category}s/${_id}`}
                  title={title}
                  {...rest}
                />
              )
            })}
          </CategoryBody>
        </CategoryWrapper>
      </div>
    </div>
  )
}